import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg className={styles["icon-svg"] || "icon-svg"} width="26" height="26" viewBox="0 0 24 24" stroke="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M6 12.2l4.3 4.2 8.1-10.3" fill="none" /></svg>;